import { useMutation, useQueryClient } from "@tanstack/react-query";
import { socialApi } from "@bw/shared/api";
import type { DirectMessageAttachmentResponse } from "@bw/shared/types/generated";
import { refreshConversationAuthorityAfterMutationError } from "../../../common/hooks/conversationCacheAuthority";

export type UploadMessageAttachmentVars = {
  file: File;
  idempotencyKey: string;
  onProgress: (percent: number) => void;
};

/**
 * Typed React-Query mutation for one private direct-message upload. The draft
 * owns the idempotency key, so retries use the exact same durable reservation
 * rather than creating another upload operation.
 */
export function useUploadMessageAttachment(
  conversationId: string,
  communityId?: string,
) {
  const client = useQueryClient();
  return useMutation<
    DirectMessageAttachmentResponse,
    unknown,
    UploadMessageAttachmentVars
  >({
    onError: (error) =>
      refreshConversationAuthorityAfterMutationError(
        client,
        conversationId,
        communityId,
        error,
      ),
    mutationFn: ({ file, idempotencyKey, onProgress }) =>
      socialApi.uploadMessageAttachment(
        conversationId,
        file,
        idempotencyKey,
        onProgress,
      ),
  });
}
